import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './firebase.config';

const COLLECTION = 'portfolioPages';

/**
 * Fetch a portfolio page by its document ID (read-only, no auth required)
 * @param {string} portfolioId - The Firestore document ID
 * @returns {Promise<Object|null>} - Portfolio object with id, or null if not found
 */
export const getPortfolioById = async (portfolioId) => {
    if (!portfolioId) return null;

    try {
        const docRef = doc(db, COLLECTION, portfolioId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return {
                id: docSnap.id,
                ...docSnap.data(),
            };
        }

        return null;
    } catch (error) {
        console.error('Error fetching portfolio:', error);
        return null;
    }
};
/**
 * Fetch a portfolio page by subdomain (read-only, no auth required)
 * @param {string} subdomain - The subdomain to search for (e.g., "user-site")
 * @returns {Promise<Object|null>} - Portfolio object with id, or null if not found
 */
export const getPortfolioBySubdomain = async (subdomain) => {
    if (!subdomain) return null;

    try {
        const searchTerm = subdomain.toLowerCase().trim();
        console.log('[publicPortfolio.service] Searching for customDomain:', searchTerm);

        const q = query(
            collection(db, COLLECTION),
            where('customDomain', '==', searchTerm)
        );
        const querySnapshot = await getDocs(q);

        console.log('[publicPortfolio.service] Query returned', querySnapshot.size, 'documents');

        if (querySnapshot.empty) {
            console.log('[publicPortfolio.service] No portfolio with customDomain:', searchTerm);
            return null;
        }

        const docSnap = querySnapshot.docs[0];
        const data = docSnap.data();

        console.log('[publicPortfolio.service] Found document:', docSnap.id);
        console.log('[publicPortfolio.service] SUCCESS: Returning portfolio');

        // All portfolios are publicly accessible - no isPublic check needed
        // Security is enforced at Firestore rules level
        return {
            id: docSnap.id,
            ...data,
        };
    } catch (error) {
        console.error('[publicPortfolio.service] Error:', error.code, '-', error.message);
        return null;
    }
};